import {createTheme} from '@mui/material'

const semiDarkTheme = createTheme({
  palette: {
    primary: {
      contrastText: "#fff",
      main: "#900C3E",
    },
    secondary: {
      contrastText: "#fff",
      main: "#475F7B",
    },
    background: {
      main: '#ffffff',
      mainDarker2: '#f9f9f9',
      mainDarker5: '#f2f2f2',
      dark: '#f2f4f4'
    },
    menu: {
      background: {
        main: '#272e48',
        dark: '#1a233a'
      }
    }
  }
});

export default semiDarkTheme